<template>
  <!-- Signed out: the Welcome board (WelcomeScreen). Signed in, / goes to
       Sessions: Mine (router/redirects.js). -->
  <welcome-screen />
</template>

<script>
import WelcomeScreen from "@/components/auth/WelcomeScreen.vue";

export default {
  name: "Home",
  components: { WelcomeScreen },
};
</script>
